<template>
  <div class="mt-0">
    <v-data-iterator 
      v-if="!loading_categories"
      :items="current_execution.categories" 
      :items-per-page.sync="itemsPerPage" 
      hide-default-footer 
      :search="search"
    >
      <template v-slot:default="{items}">
        <v-row justify="center" v-if="items" class="pa-1">
          <v-col v-for="(item, item_idx) in items" :key="item_idx" class="ma-2" cols="11" md='10'>
            <category-card :item="item" :item_idx='item_idx'></category-card>
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations} from 'vuex'

export default {
  name: 'CategoryTable',
  components: {
    CategoryCard: () => import('./CategoryCard')
  },
  data() {
    return {
      search: null,
      itemsPerPage: -1,
      local_current_time: null,
      loading_categories: false,
    }
  },
  methods: {
    ...mapMutations({
      setCurrentTime: 'Execution/setCurrentTime'
    })
  },
  computed: {
    ...mapState({
      current_execution: state => state.Execution.current_execution,
      current_time: state => state.Execution.current_time,
      current_time_idx: state => state.Execution.current_time_idx,
      profile: state => state.User.profile
    }),
  },
  watch: {
    current_time_idx(nv, ov) {
      if(nv){
      }
    },
    current_time(nv, ov) {
      if(nv){
      }
    },
  },

}
</script>

<style lang="scss" scoped>

</style>